/* Shop + Home Highlights gateway card carousel — continuous loop scroll.
   DEC-378: the strip used to move by `scrollLeft += 0.4` each frame. Chrome and Edge keep scrollLeft in whole
   (device) pixels, so on standard-density screens (most desktop and ultra-wide monitors) 0.4 rounded to 0 every
   frame and the strip never moved; Safari keeps fractions, which is why phones and Macs scrolled. The true position
   now lives in `pos` and the browser only receives whole pixels, so motion accumulates on every screen.
   Speed is time-based (pixels per second), so it is the same at 60, 120 or 144 Hz.
   Editable in the theme editor (RK Shop hero / Home Highlights): data-rk-autoplay ("true"/"false") and
   data-rk-speed (pixels per second, default 24 — the old 0.4 px × 60 fps). */
(function () {
  var NUDGE_MS = 420;

  function isReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function init(root) {
    if (!root || root.dataset.rkShopGatesReady === '1') return;
    var track = root.querySelector('[data-rk-shop-gates-track]');
    var previous = root.querySelector('[data-rk-shop-gates-prev]');
    var next = root.querySelector('[data-rk-shop-gates-next]');
    if (!track) return;
    var originals = Array.prototype.slice.call(track.children).filter(function (el) { return !el.classList.contains('is-loop-clone'); });
    if (originals.length < 2) return;
    root.dataset.rkShopGatesReady = '1';

    var autoplay = root.getAttribute('data-rk-autoplay') !== 'false';
    var speed = parseFloat(root.getAttribute('data-rk-speed'));
    if (!(speed > 0)) speed = 24;

    var loopWidth = 0, stepWidth = 0, paused = false, nudgeTimer = null;
    var pos = 0, last = 0, writing = false;

    function gapSize() {
      var s = window.getComputedStyle(track);
      return parseFloat(s.columnGap || s.gap || 0) || 0;
    }
    function measure() {
      var gap = gapSize();
      stepWidth = Math.round(originals[0].getBoundingClientRect().width + gap);
      loopWidth = 0;
      originals.forEach(function (el) { loopWidth += el.getBoundingClientRect().width + gap; });
    }
    function clearClones() {
      track.querySelectorAll('.is-loop-clone').forEach(function (el) { el.remove(); });
    }
    function buildLoop() {
      clearClones();
      /* enough copies to keep the strip full even on very wide screens */
      var copies = 1;
      measure();
      while (loopWidth > 0 && loopWidth * copies < track.clientWidth + loopWidth && copies < 6) copies++;
      for (var c = 0; c < copies; c++) {
        originals.forEach(function (el) {
          var clone = el.cloneNode(true);
          clone.classList.add('is-loop-clone');
          clone.setAttribute('aria-hidden', 'true');
          clone.setAttribute('tabindex', '-1');
          clone.removeAttribute('id');
          track.appendChild(clone);
        });
      }
      track.style.scrollBehavior = 'auto';
    }
    function setPos(p) {
      if (loopWidth > 0) { while (p >= loopWidth) p -= loopWidth; while (p < 0) p += loopWidth; }
      pos = p;
      writing = true;
      track.scrollLeft = Math.round(pos);
      writing = false;
    }
    /* keep pos in step with manual swipes and the arrow buttons */
    track.addEventListener('scroll', function () {
      if (writing) return;
      if (Math.abs(track.scrollLeft - Math.round(pos)) > 1) {
        pos = track.scrollLeft;
        if (loopWidth > 0 && pos >= loopWidth) setPos(pos);
      }
    }, { passive: true });

    function tick(now) {
      var dt = last ? Math.min(now - last, 100) : 0;
      last = now;
      if (autoplay && !paused && !isReducedMotion() && loopWidth > 0) setPos(pos + speed * dt / 1000);
      window.requestAnimationFrame(tick);
    }
    function stopMotion() { paused = true; if (nudgeTimer) window.clearTimeout(nudgeTimer); }
    function resumeMotion(delay) {
      if (nudgeTimer) window.clearTimeout(nudgeTimer);
      nudgeTimer = window.setTimeout(function () { paused = false; }, delay || 0);
    }
    function nudge(direction) {
      if (!stepWidth) return;
      stopMotion();
      setPos(pos + direction * stepWidth);
      resumeMotion(1800);
    }

    buildLoop();
    setPos(0);

    if (previous) previous.addEventListener('click', function (e) { e.preventDefault(); nudge(-1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); nudge(1); });
    root.addEventListener('mouseenter', stopMotion);
    root.addEventListener('mouseleave', function () { resumeMotion(400); });
    root.addEventListener('focusin', stopMotion);
    root.addEventListener('focusout', function () { resumeMotion(400); });
    root.addEventListener('touchstart', stopMotion, { passive: true });
    root.addEventListener('touchend', function () { resumeMotion(2500); }, { passive: true });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopMotion(); else resumeMotion(400);
    });
    var rt = null;
    window.addEventListener('resize', function () {
      window.clearTimeout(rt);
      rt = window.setTimeout(function () {
        var ratio = loopWidth > 0 ? pos / loopWidth : 0;
        buildLoop();
        setPos(ratio * loopWidth);
      }, 150);
    });
    window.requestAnimationFrame(tick);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-rk-shop-gates]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
